import { push, set } from "firebase/database";
import { ChatMessageEnums } from "./index";

export default class ChatMessage {
  constructor({ kind = ChatMessageEnums.TEXT }) {
    this.isLatestMessage = false;
    this.kind = kind;
  }

  update() {
    try {
      set(this._getMessageRef(), {
        ...this._getBasePayload(),
        ...this._getPayload(),
      });
    } catch (err) {
      console.error(err);
    }
  }

  _create() {
    try {
      push(this._getInboxRef(), {
        ...this._getBasePayload(),
        ...this._getPayload(),
      });
    } catch (err) {
      console.error(err);
    }
  }

  _getBasePayload() {
    const { kind } = this;

    return {
      kind,
    };
  }

  send() {
    try {
      if (!this._isValidMessage()) throw new Error("Message can't be empty");
      this._create();
    } catch (err) {
      console.error(err);
    }
  }

  _isValidMessage() {
    return this.message.replace(/\s/g, "").length > 0;
  }

  setIsLatestMessage(value) {
    this.isLatestMessage = Boolean(value);
  }

  getUrlParams() {
    return this._urlParams;
  }

  _getDisplayName(me) {
    return `${me.user?.firstName ?? "No Name"} ${
      me.user?.lastName?.[0] ?? me.user.id
    }`;
  }

  toObject() {
    return {
      ...this._getBasePayload(),
      ...this._getPayload(),
    };
  }

  toJSON() {
    return JSON.stringify(this.toObject());
  }

  _camelCaseify(obj) {
    const newObj = {};

    Object.entries(obj).forEach(([key, val]) => {
      const newKey = key.replace(/([-_][a-z])/g, (group) =>
        group.toUpperCase().replace("-", "").replace("_", "")
      );

      newObj[newKey] = val;
    });

    return newObj;
  }
}
